import envDetails from './envDetails'

var cloudFunctionBase=""
var res=""
var prophetApi = ""
if(process.env.NODE_ENV == "staging") {
    res = envDetails.stageServerApi
    prophetApi = envDetails.stageProphetApi
    cloudFunctionBase = envDetails.stageCloudFunctionBase
    console.log("Connected to STAGING server")
}else if(process.env.NODE_ENV == "production"){
    res = envDetails.prodServerApi
    prophetApi = envDetails.prodProphetApi
    cloudFunctionBase= envDetails.prodCloudFunctionBase
    console.log("Connected to PRODUCTION server")
}else{
    // SERVER   
    // var res=envDetails.stageServerApi
    // console.log("Connected to STAGING server")

    res= envDetails.devServerApi
    prophetApi = envDetails.stageProphetApi
    console.log("Connected to DEV (local) server")

    // CLOUD FUNCTION
    cloudFunctionBase= envDetails.stageCloudFunctionBase

}

export const getServerApi = () => {
    return res
}

export const getCloudFunctionBase=()=>{
    return cloudFunctionBase
}

export const getProphetApi=()=>{
    return prophetApi
}



// WEBPACK FOOTER //
// ./src/config/deployment.js